import ExperiencePage from "./ExperiencePage";
import { IMG } from "../../i18n/marketingImages";

export default function ExperienceAllInOne() {
  return <ExperiencePage expKey="allInOne" image={IMG.allInOne} />;
}
